module.exports = __webpack_public_path__ + "static/media/img_media.b0fdc46e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_media.jpg
// module id = 435
// module chunks = 4